/**
 * Functions for modifying SVGs and SVG elements.
 */

import { BBox } from "svg-path-bbox";

/**
 * The innerHTML/outerHTML properties of an element does not respect case.
 * This function restores case to case-sensitive elements.
 */
export const fixCase = (svg: string): string => {
    let str = svg;
    str = str.replace(/feoffset/gi, "feOffset");
    str = str.replace(/fegaussianblur/gi, "feGaussianBlur");
    str = str.replace(/feblend/gi, "feBlend");
    str = str.replace(/lineargradient/gi, "linearGradient");
    str = str.replace(/stddeviation/gi, "stdDeviation");
    return str;
};

// Translate and scale the group containing the text.
export function transformTextEnclosure(
    textEnclosure: SVGElement,
    textBbox: BBox,
    boundsHeight: number,
    boundsWidth: number,
    heightPaddingFactor?: number,
    widthPaddingFactor?: number,
) {
    const heightPadFactor = heightPaddingFactor || 1;
    const widthPadFactor = widthPaddingFactor || 1;

    const textRect = {
        x: textBbox[0],
        y: textBbox[1],
        width: textBbox[2] - textBbox[0],
        height: textBbox[3] - textBbox[1],
    };
    if (textRect.width <= 0) {
        return;
    }
    const scaleFactor = boundsScaleFactor(textRect.height, textRect.width, boundsHeight*heightPadFactor, boundsWidth*widthPadFactor);
    const shiftLeft = (boundsWidth - scaleFactor * textRect.width) / 2 - scaleFactor * textRect.x;
    const shiftTop = (boundsHeight - scaleFactor * textRect.height) / 2 - scaleFactor * textRect.y;
    textEnclosure.setAttribute("transform", `translate(${shiftLeft} ${shiftTop}) scale(${scaleFactor} ${scaleFactor})`);
}

// Factor to multiply text dimensions by to scale it to the supplied bounds.
function boundsScaleFactor(textRectHeight: number, textRectWidth: number, boundsHeight: number, boundsWidth: number) {
    const heightRatio = boundsHeight / textRectHeight;
    const widthRatio = boundsWidth / textRectWidth;
    if (heightRatio > 1 && widthRatio > 1) {
        // Text smaller than bounds.
        return Math.min(heightRatio, widthRatio);
    } else if (heightRatio > 1 && widthRatio < 1) {
        // Text shorter but wider than bounds.
        return widthRatio;
    } else if (heightRatio < 1 && widthRatio > 1) {
        // Text narrower but taller than bounds.
        return heightRatio;
    }
    return Math.min(heightRatio, widthRatio); // Text larger than bounds.
}
